/**
 * The liquid units a design is shown in (D49), for the components that show or
 * take volumes and flows. Provided by the design workspace from the server's
 * resolved setting; outside one (a test, a thumbnail), null, and each
 * component keeps its own choice.
 */
import { createContext, useContext } from "react";
import { TUBING_SET_UNITS, type LiquidUnits } from "./units";

export const DisplayUnitsContext = createContext<LiquidUnits | null>(null);

/** The design's liquid units, or null outside a design workspace. */
export function useDesignLiquidUnits(): LiquidUnits | null {
  return useContext(DisplayUnitsContext);
}

/** The design's liquid units, or a tubing set's where no design says. */
export function useLiquidUnits(): LiquidUnits {
  return useContext(DisplayUnitsContext) ?? TUBING_SET_UNITS;
}
